import React, { useState, useRef, useContext } from "react";
import { Link } from "react-router-dom";
import Navbar from "../components/header/Navbar";
import { AuthContext } from "../context/AuthContext";
// import ThemeToggle from '../components/common/ThemeToggle';

const Header = ({ handleLogout }) => {
  const { payload, token, isAdmin } = useContext(AuthContext);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Construct user info from token payload
  const user = token
    ? {
      id: payload?.sub || payload?.user_id || payload?.id || null,
      name: payload?.name || payload?.user?.name || "User",
      email: payload?.email || payload?.user?.email || "",
      profileImage:
        payload?.profile_picture ||
        payload?.avatar ||
        payload?.user?.profileImage ||
        "",
    }
    : null;

  // Close dropdown on outside click
  React.useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);


  const getInitials = (name) => {
    if (!name || typeof name !== 'string') return 'U';
    const parts = name.trim().split(/\s+/);
    if (parts.length > 1) {
      return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
    }
    return parts[0][0].toUpperCase();
  };

  return (
    <header className="bg-white shadow-md fixed top-0 left-0 w-screen z-50">
      <div className="mx-auto px-4 sm:px-6 lg:px-8 py-0 h-full">
        <div className="flex items-center justify-between h-full">
          {/* Left: Sidebar Toggle */}
          <div className="">
            <Navbar />
          </div>

          {/* Center: Title - Takes available space and centers text */}
          {/* <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2">
            <h1 className="text-2xl md:text-3xl font-bold text-blue-600 tracking-wide whitespace-nowrap">
              MdZaar
            </h1>
          </div> */}

          {/* Right side: Profile + Theme Toggle */}
          {/* <div className="flex items-center space-x-4">
            <ThemeToggle />
          </div> */}

          {/* Right: Profile / Login */}
          <div className="flex items-center space-x-4">
            {token && user ? (
              <div className="relative" ref={dropdownRef}>
                <button
                  onClick={() => setDropdownOpen(!dropdownOpen)}
                  className="flex items-center focus:outline-none focus:ring-2 focus:ring-blue-500 rounded-full"
                  aria-label="User menu"
                >
                  {user.profileImage ? (
                    <img
                      src={user.profileImage}
                      alt="Profile"
                      className="w-10 h-10 rounded-full object-cover border-2 border-white shadow-md"
                    />
                  ) : (
                    <div className="w-10 h-10 rounded-full bg-blue-600 text-white flex items-center justify-center font-bold text-lg border-2 border-white shadow-md">
                      {getInitials(user.name)}
                    </div>
                  )}
                </button>

                {/* Dropdown */}
                {dropdownOpen && (
                  <div className="absolute right-0 mt-2 w-64 bg-white rounded-lg shadow-2xl border border-gray-200 py-2 z-50">
                    <div className="px-4 py-3 border-b border-gray-200">
                      <p className="block font-semibold text-gray-900 truncate  px-2 py-2 rounded-md transition-colors duration-200 ease-in-out hover:bg-red-100 hover:text-red-800 focus:bg-red-100 focus:text-red-800 focus:outline-none focus:ring-2 focus:ring-red-300 active:bg-red-200 active:text-red-900">{user.name}</p>
                      <p className="block text-sm text-gray-500 truncate  px-2 py-2 rounded-md transition-colors duration-200 ease-in-out hover:bg-red-100 hover:text-red-800 focus:bg-red-100 focus:text-red-800 focus:outline-none focus:ring-2 focus:ring-red-300 active:bg-red-200 active:text-red-900">{user.email}</p>


                      {/* {isAdmin && (
                        <Link
                          to="/admin"
                          className="block px-2 py-2 text-red-600 font-semibold rounded-md transition-colors duration-200 ease-in-out hover:bg-red-100 hover:text-red-800 focus:bg-red-100 focus:text-red-800 focus:outline-none focus:ring-2 focus:ring-red-300 active:bg-red-200 active:text-red-900"
                        >
                          Admin Dashboard
                        </Link>
                      )} */}

                    </div>
                    <button
                      onClick={() => {
                        handleLogout();
                        setDropdownOpen(false);
                      }}
                      className="w-full text-left px-4 py-3 text-red-600 hover:bg-red-50 transition-colors font-medium"
                    >
                      Logout
                    </button>
                  </div>
                )}
              </div>
            ) : (
              <Link
                to="/login"
                className="hidden md:block px-5 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-lg font-medium transition-colors"
              >
                Login
              </Link>
            )}
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;